// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"dcb0c397","769":"57f883b9"}[chunkId] + ".chunk.js";
};